'use client';
import { type ReactNode, useRef, useEffect } from 'react';

import { sendViewItemEventAtomFn } from '../../effect/atom/gtm/sendViewItemEvent';
import type { GtmViewItemEvent } from '@vs-shop/schemas/gtm/view-item';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  gtmEvent: GtmViewItemEvent;
  children: ReactNode;
};

export default function ViewProductTracker({ gtmEvent, children }: Props) {
  const sendViewItemEvent = useAtomSet(sendViewItemEventAtomFn, { mode: 'promiseExit' });
  const eventSent = useRef(false);

  useEffect(() => {
    if (eventSent.current) return;
    void sendViewItemEvent(gtmEvent);
    eventSent.current = true;
  }, [gtmEvent, sendViewItemEvent]);

  return children;
}
